import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'searchResult/FETCH_REQUEST';
const FETCH_SUCCESS = 'searchResult/FETCH_SUCCESS';
const FETCH_FAILURE = 'searchResult/FETCH_FAILURE';
const FETCH_ALL_REQUEST = 'searchResult/FETCH_ALL_REQUEST';
const FETCH_ALL_SUCCESS = 'searchResult/FETCH_ALL_SUCCESS';
const FETCH_ALL_FAILURE = 'searchResult/FETCH_ALL_FAILURE';
const CLEAR_ALL_REQUEST = 'searchResult/CLEAR_ALL_REQUEST';

const initialState = {
    result: {
        search_results: [],
        page: 1,
        per_page: 25,
        pages: 10
    },
    all_result: {
        search_results: []
    },
    loaded: false,
    loading: false,
    allLoaded: false,
    allLoading: false,
    errors: []
};

export function fetchRequest(payload = {}){
    return {
        type: FETCH_REQUEST
    }
}

export function fetchSuccess(payload){
    return {
        type: FETCH_SUCCESS,
        payload
    }
}

export function fetchFailure(errors = []){
    return {
        type: FETCH_FAILURE,
        errors
    }
}

export function fetchAllRequest(payload = {}){
    return {
        type: FETCH_ALL_REQUEST
    }
}

export function fetchAllSuccess(payload){
    return {
        type: FETCH_ALL_SUCCESS,
        payload
    }
}

export function fetchAllFailure(errors = []){
    return {
        type: FETCH_ALL_FAILURE,
        errors
    }
}

export function clearAllRequest(payload){
    return {
        type: CLEAR_ALL_REQUEST,
        payload
    }
}

export function clearAllSearchResultData() {
    return(dispatch) => {
        dispatch(clearAllRequest({search_results: []}));
    }
}

export function loadSearchResultData(options = {}, callback) {
    return (dispatch) => {
        dispatch(fetchRequest());

        return api('api/v1/searches/result', options)
          .then(response => response.json().then(json => ({ json, response })))
          .then(({ json, response }) => {
              if (!response.ok) {
                  return Promise.reject(json)
              }
              dispatch(fetchSuccess(json))
              callback()
          })
          .catch((exception) => {
              handleAPIErrors(exception, (errors) => {
                dispatch(fetchFailure(errors))
              })
              callback()
          });
    }
}

export function loadAllSearchResultData(options = {}) {
    return (dispatch) => {
        dispatch(fetchAllRequest());

        return api('api/v1/searches/result', options)
          .then(response => response.json().then(json => ({ json, response })))
          .then(({ json, response }) => {
              if (!response.ok) {
                  return Promise.reject(json)
              }

              dispatch(fetchAllSuccess(json))
          })
          .catch((exception) => {
              handleAPIErrors(exception, (errors) => {
                dispatch(fetchAllFailure(errors))
              })
          });
    }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
    const { payload, type, errors } = action;

    switch (type) {
        case FETCH_REQUEST:
            return Object.assign({}, state, {
                loading: true
            });
        case FETCH_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                loaded: true,
                errors: [],
                result: payload
            });
        case FETCH_FAILURE:
            return Object.assign({}, state, {
                loaded: false,
                loading: false,
                errors
            });
        case FETCH_ALL_REQUEST:
            return Object.assign({}, state, {
                allLoading: true
            });
        case FETCH_ALL_SUCCESS:
            return Object.assign({}, state, {
                allLoading: false,
                allLoaded: true,
                errors: [],
                all_result: payload
            });
        case FETCH_ALL_FAILURE:
            return Object.assign({}, state, {
                allLoaded: false,
                allLoading: false,
                errors
            });
        case CLEAR_ALL_REQUEST:
            return Object.assign({}, state, {
                allLoading: false,
                allLoaded: false,
                errors: [],
                all_result: payload
            });
        default:
            return state
    }
}
